import { Card } from '@cimpress/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import orderBy from 'lodash/orderBy';
import { textOverflowEllipsisStyle } from '../../common/CommonCss';
import { css, cx } from 'emotion';
import { platinum } from '@cimpress/react-components/lib/colors';
import StatusCell from '../contractTable/StatusCell';
import { selectors as termSelectors } from '../../../reducers/terms';
import { connect } from 'react-redux';
import Loading from '../../Loading';
import { history } from '../../../utils/history';
import PropTypes from 'prop-types';

const cardBody = css({
  '& > .card-block': {
    padding: '5px 0px'
  }
});

const rowStyle = css({
  '&:not(:last-child)': {
    marginBottom: '5px',
    paddingBottom: '5px',
    borderBottom: `1px solid ${platinum}`
  },
  display: 'flex',
  alignItems: 'center',
  padding: '0px 16px'
});

const linkStyle = css({
  flexBasis: 'content',
  cursor: 'pointer',
  color: '#0088a9'
});

function RecentlyCreatedContractsCard({ terms, isTermsLoading, numberToDisplay }) {
  const { t } = useTranslation();
  const orderedTerms = orderBy(terms, ['createdAt'], ['desc']);
  const mostRecentTerms = orderedTerms.slice(0, numberToDisplay);

  return (
    <Card header={t('landingPage:recentlyCreatedContractsCard:header')} isMinimal className={cardBody}>
      {isTermsLoading ? (
        <Loading />
      ) : (
        mostRecentTerms.map((term, index) => (
          <div className={cx('card-text', rowStyle)} key={index}>
            <span
              className={cx(linkStyle, textOverflowEllipsisStyle)}
              onClick={() => history.push(`/${term.termId}/${term.revisionId}`)}>
              {term.additionalData.name}
            </span>
            <hr />
            <StatusCell term={term} />
          </div>
        ))
      )}
    </Card>
  );
}

RecentlyCreatedContractsCard.propTypes = {
  terms: PropTypes.arrayOf(PropTypes.object).isRequired,
  numberToDisplay: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  isTermsLoading: termSelectors.getIsTermsLoading(state)
});

export default connect(
  mapStateToProps,
  null
)(RecentlyCreatedContractsCard);
